import React, { useEffect, useState } from "react";
import "./Select_Product_By_Weight_Modal.css";
import { Button, Modal } from "react-bootstrap";
import { Navigate, useNavigate } from "react-router-dom";
import {
  faBasketShopping,
  faX,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IncrementDecrementBtn from "../../Increment_Decrement_Btn/Increment_Decrement_Btn";
import Green_Btn from "../../common_btn/green_btn/Green_Btn";
import GotoCartModal from "../goto_cart_modal/GotoCartModal";
import "../goto_cart_modal/GotoCartModal.css";
import Common_Goto_Cart_Card from "../../common_goto_cart_card/Common_Goto_Cart_Card";
import {
  getAllCart,
  postCart,
  postCartQuantity,
} from "../../../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";

function Select_Product_By_Weight_Modal(props) {
  const navigate = useNavigate();
  const [addCartBTNShow, setaddCartBTNShow] = useState(false);
  const [showGoToCartModal, setshowGoToCartModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0); // default first card active
  const products = [
    {
      weight: "0.5 Kg",
      selling_price: "₹ 120.00",
      mrp: "₹ 120.00",
      discount: "-20%",
    },

    {
      weight: "0.5 Kg",
      selling_price: "₹ 120.00",
      mrp: "₹ 120.00",
      discount: "-20%",
    },

    {
      weight: "0.5 Kg",
      selling_price: "₹ 120.00",
      mrp: "₹ 120.00",
      discount: "-20%",
    },

    {
      weight: "0.5 Kg",
      selling_price: "₹ 120.00",
      mrp: "₹ 120.00",
      discount: "-20%",
    },

    {
      weight: "0.5 Kg",
      selling_price: "₹ 120.00",
      mrp: "₹ 120.00",
      discount: "-20%",
    },
  ];

  const [totalSaving, setTotalSaving] = useState();
  const [totaAmount, setTotalAmount] = useState();

  const [showFooter, setShowFooter] = useState(false);
  const [footerClosing, setFooterClosing] = useState(false);

  const closeFooter = () => {
    setFooterClosing(true);
    setTimeout(() => {
      setShowFooter(false);
      setFooterClosing(false);
    }, 300);
  };

  const dispatch = useDispatch();
  const isSignIn = useSelector((state) => state.auth.is_signin);

  const inCart = useSelector((state) => state.cart.checkItem);
  const [Errors, setErrors] = useState();
  const addToCart = async (product_id, variant_id) => {
    if (1 >= Number(props.varient?.general_stock)) {
      setErrors("Out of Stock");
    }
    setErrors("");
    setaddCartBTNShow(true);
    setShowFooter(true);
    try {
      const data = {
        product_id: product_id,
        variant_id: variant_id,
      };
      const res = await dispatch(postCart({ data: data, isSignIn: isSignIn }));
      if (res.meta?.requestStatus === "fulfilled") {
        await dispatch(getAllCart(isSignIn));
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };
  const allCart = useSelector((state) => state.cart.allCarts);

  // useEffect(() => {
  //   dispatch(getAllCart(isSignIn));
  // }, []);

  const saveTotal = () => {
    let total = 0;
    let savings = 0;
    let count = 0;

    if (allCart?.data?.data?.length > 0) {
      for (const element of allCart?.data?.data) {
        const price = Number(element?.Product_Variant?.price);
        const mrp = Number(element?.Product_Variant?.mrp);
        const qty = Number(element.quantity);
        total += price * qty;
        savings += (mrp - price) * qty;
        count += 1;
        // setTotalAmount(total)
        // setTotalSaving(savings)
        // setCount(count)
      }
    }
    const data = {
      total: total,
      savings: savings,
      count: count,
    };

    return data;
  };

  return inCart ? (
    <>
      <section className="Select_Product_By_Weight_Modal modal-holder">
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="Select_Product_By_Weight_Modal modal-holder"
        >
          <Modal.Body>
            <div className="header_part">
              <div className="left_side">
                <div className="img_holder">
                  <img
                    src={process.env.REACT_APP_IMG_URL + props?.product?.image}
                  />
                </div>
                <div className="product_name">
                  <p>{props?.product?.name}</p>
                </div>
              </div>
              <div className="right_side">
                <FontAwesomeIcon
                  icon={faX}
                  className="close_icon"
                  onClick={() => {
                    props?.onHide();
                  }}
                />
              </div>
            </div>
            <div className="body_part">
              {props?.product?.Product_Variants?.map((varient, index) => {
                const isIn = allCart?.data?.data?.some(
                  (item) => item?.variant_id === varient?.id
                );
                return (
                  <div className="row_holder" key={index}>
                    <div className="left_side Product_Description">
                      <div className="product_price_info">
                        <div className="price_section">
                          <div className="kilo_div">
                            <p className="kilo_text">
                              {varient?.name} {props?.product?.Unit?.name}
                            </p>
                          </div>
                          <div className="main_price_holder">
                            <div className="selling_price">
                              <p>
                                ₹
                                {(
                                  Number(varient?.price || 0) 
                                
                                ).toFixed(2)}
                              </p>
                            </div>

                            <div className="mrp">
                              <p>
                                ₹
                                {(
                                  Number(varient?.mrp || 0) 
                                 
                                ).toFixed(2)}
                              </p>
                            </div>
                          </div>

                          {/* <div className="main_price_holder">
                            <div className="selling_price">
                              <p>{varient?.price}</p>
                            </div>

                            <div className="mrp">
                              <p>{varient?.mrp}</p>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="right_side">
                      <div className="btn_holder">
                        {Number(varient?.general_stock) <= 0 ? (
                          <div>
                            <button className="btn btn-danger" disabled>
                              Out of Stock
                            </button>
                          </div>
                        ) : isIn ? (
                          <IncrementDecrementBtn
                            varient={varient}
                            product={props?.product}
                            varientId={varient?.id}
                            cart={allCart?.data?.data}
                            productId={props?.product?.id}
                            isSignIn={isSignIn}
                          />
                        ) : (
                          <div>
                            <Green_Btn
                              varient={varient}
                              btn_name="Add to Cart"
                              leftIcon={faBasketShopping}
                              onClick={() =>
                                addToCart(varient?.product_id, varient?.id)
                              }
                            />
                          </div>
                        )}

                        {Errors && <p style={{ color: "red" }}>{Errors}</p>}
                      </div>

                      {/* <div className="btn_holder">
                        {isIn ? (
                          <IncrementDecrementBtn
                            varient={varient}
                            varientId={varient?.id}
                            cart={allCart?.data?.data}
                            productId={props?.product?.id}
                            isSignIn={isSignIn}
                          />
                        ) : Number(varient?.general_stock) <= 0 ? (
                          <div>
                            <button className="btn btn-danger" disabled>
                              Out of Stock
                            </button>
                          </div>
                        ) : (
                          <div>
                            <Green_Btn
                              varient={varient}
                              btn_name="Add to Cart"
                              leftIcon={faBasketShopping}
                              onClick={() =>
                                addToCart(varient?.product_id, varient?.id)
                              }
                            />
                          </div>
                        )}
                        {Errors && <p style={{ color: "red" }}>{Errors}</p>}
                      </div> */}
                    </div>
                  </div>
                );
              })}
            </div>
          </Modal.Body>

          {showFooter && (
            <Modal.Footer
              className={`GotoCartModal ${footerClosing ? "slide-out-left" : ""
                }`}
            >
              <div className="modal-content">
                <div className="modal-body">
                  <Common_Goto_Cart_Card
                    inCart={props?.product}
                    saveTotal={saveTotal}
                    onClose={closeFooter}
                  />
                </div>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </section>
    </>
  ) : (
    <></>
  );
}

export default Select_Product_By_Weight_Modal;

// if (res.meta?.requestStatus === 'fulfilled') {
//     const foundItem = res?.payload?.cart_item;
//     console.log(foundItem, 'foundItemfoundItem');

//     if (foundItem) {
//         setInCart(foundItem);
//     } else {
//         setInCart(foundItem);
//     }
// } else {
//     console.log('Error: Product not in cart hereeeeee', res.payload || 'Not In Cart');
//     setInCart(false);
// }

// useEffect(() => {
//     console.log(isSignIn, "isSignIn");
//     dispatch(getAllCart(isSignIn));

// }, [dispatch, props?.product, props?.selectedVariant?.id, isSignIn]);

// console.log(inCart, "dfffff", props?.selectedVariant, 'inCart');

// //-----------------cartQuantity-------------

// const cartQuantity = async (type) => {
//     try {
//         const data = {
//             cart_id: inCart?.cart_item?.id,
//             type: type, isSignIn,
//             product_id: inCart?.cart_item?.product_id,
//             variant_id: inCart?.cart_item?.variant_id,
//         }
//         console.log("2222222222222", data);

//         const res = await dispatch(postCartQuantity({ data: data }));
//         if (res.meta?.requestStatus === "fulfilled") {
//         } else if (res.meta?.requestStatus === "rejected") {
//             console.log("Error:", res.payload || "Not In Cart");
//         }
//     } catch (error) {
//         console.log("Error:", error);
//     }
// };
